import { api, endpoints } from "api/api";
import { CourseSessionApi } from "../courseSessionsApi";

const fetchByCourseId = (courseId: number) => {
  return api.get<FetchScheduleEventsResponse>(endpoints.SCHEDULE_EVENTS.GET(courseId));
};

export const scheduleEventsApi = { fetchByCourseId };

interface FetchScheduleEventsResponse {
  events: ScheduleEventApi[];
  isReady: boolean;
}

export interface ScheduleEventApi {
  id: number;
  dateFrom: Date;
  dateTo: Date;
  timeFrom: string;
  timeTo: string;
  session: CourseSessionApi;
  placeType: number;
  placeName?: string;
  placeId?: number;
  topicName?: string;
  topicId?: number;
  topicGroupName?: string;
  topicGroupId?: number;
  examName?: string;
  examId?: number;
  totalPrice: number;
  type?: number;
  trainersPrices: {
    price: number;
    trainerId: number;
    trainerFirstName: string;
    trainerSurname: string;
    trainerEmail: string;
  }[];
}
